import { makeUseAxios } from 'axios-hooks';
import { LRUCache } from 'lru-cache';
import axios from 'axios';
import { env } from 'Shared/constants/env';
import { makeApiHooks } from './makeHooks';

const cache = new LRUCache<any, any>({ max: 10 });

const axiosInstance = axios.create({
  baseURL: `${env.rewardsHostname}/rewards/api`,
  headers: { Source: `core-app/${env.versionNumber}` },
});

const useAxios = makeUseAxios({
  axios: axiosInstance,
  cache: cache as any,
});

export const {
  useLazyApi: useLazyRewardsApi,
  useApi: useRewardsApi,
  useNewApi: useNewRewardsApi,
} = makeApiHooks(useAxios);
